import { ROLE } from 'src/constants/config'
import { allRoutes } from 'src/routes/index'
import * as roleService from 'src/services/roleService'

export function checkRole(route, userContext) {
  const { logged } = userContext

  if (logged && !route.roles) {
    return true
  }

  if (logged && route.roles && roleService.roleHasMinimumLevelOf(userContext, route.roles)) {
    return true
  }

  return false
}

export function roleHasMinimumLevelOf(userContext, minimumAccesslevel) {
  const { data } = userContext

  return data.IDPerfilAcesso <= minimumAccesslevel || data.IDPerfilAcesso === ROLE.ROOT
}

export function roleIsContadorRootAdmin(userContext) {
  const { data } = userContext

  return (
    data.IDPerfilAcesso === ROLE.CONTADOR ||
    data.IDPerfilAcesso === ROLE.ROOT ||
    data.IDPerfilAcesso === ROLE.ADMINISTRADOR
  )
}

export function roleIsRootAdmin(userContext) {
  const { data } = userContext

  return data.IDPerfilAcesso === ROLE.ROOT || data.IDPerfilAcesso === ROLE.ADMINISTRADOR
}

export function roleIsRoot(userContext) {
  const { data } = userContext

  return data.IDPerfilAcesso === ROLE.ROOT
}

export function roleIsAdmin(userContext) {
  const { data } = userContext

  return data.IDPerfilAcesso === ROLE.ADMINISTRADOR
}

export function roleIsContador(userContext) {
  const { data } = userContext

  return data.IDPerfilAcesso === ROLE.CONTADOR
}

export function checkRoleByRoutes(routeToCheck, userContext) {
  const route = allRoutes.find((r) => {
    return r.path === routeToCheck
  })

  return checkRole(route, userContext)
}
